import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getPurchasePayments } from "api/purchasePayment.api";
import { gracefulList } from "lib/queryHelpers";
import { QUERY_KEYS } from "config/queryKeys";
import { DEFAULT_STALE_TIME } from "config/constants";

const mapPayment = (p) => ({
  id: p.id || p._id,
  vendorId: p.vendorId,
  vendorName: p.vendorName || "—",
  expenseNumber:
    Array.isArray(p.allocations) && p.allocations.length
      ? `${p.allocations.length} bill(s)`
      : "—",
  date: p.paymentDate,
  paymentMode: p.paymentMode,
  amount: p.amount,
  paidFrom: p.depositTo || p.issuer || "—",
  reference: p.reference || "",
  comments: p.comments || "",
  status: p.status,
  raw: p,
});

export const useGetPurchasePayments = (params = {}) => {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: QUERY_KEYS.purchasePayments.list(),
    queryFn: gracefulList(() => getPurchasePayments(params), { payments: [] }),
    initialData: () =>
      queryClient.getQueryData(QUERY_KEYS.purchasePayments.list()),
    select: (data) => (data?.payments || []).map(mapPayment),
    staleTime: DEFAULT_STALE_TIME,
  });
};
